import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ExitTestButton from '../../testOverview/ExitTestButton';
import { clearPhotoData } from '../../../actions/IdVerificationActions';
import NextButton from './NextButton';

/**
 * This component allows either:
 * - go to the next step if the photo is approved, or,
 * - to quit the test if the photo is rejected.
 *
 * As a rejected photo prevents you from continuing the test, it is better to
 * directly add a button to quit the test. This way, if the student fails to
 * take a valid photo, they can still end the test and try again later.
 */
class CapturedPhotoCheckpointNavigationButton extends React.PureComponent {
    static propTypes = {
        approved: PropTypes.bool.isRequired,
        onNext: PropTypes.func.isRequired,
        clearPhotoData: PropTypes.func.isRequired,
    };

    handleNextClick = () => {
        this.props.clearPhotoData();
        this.props.onNext();
    };

    render() {
        const { approved } = this.props;

        if (approved) {
            return <NextButton onNext={this.handleNextClick} />;
        }

        return <ExitTestButton showButtonForNonLockdown />;
    }
}

const mapDispatchToProps = {
    clearPhotoData,
};

export default connect(null, mapDispatchToProps)(CapturedPhotoCheckpointNavigationButton);

